// extracted by mini-css-extract-plugin
export default {"container":"style_container__fC1NF","image":"style_image__ZnUsg","title":"style_title__5ZZw2","subtitle":"style_subtitle__EhsoM"};